export const stringToColor = str => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${Math.abs(hash) % 360}, 60%, 42%)`;
};

export const getInitials = (firstName, lastName) =>
  `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';

export const formatDate = dateStr => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('tr-TR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const formatCurrency = amount => {
  if (!amount && amount !== 0) return '—';
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const getJobStatusColor = (status, theme) => {
  const map = {
    YAZIMDA: theme.palette.info.main,
    DEGERLENDIRMEDE: theme.palette.warning.main,
    ONAYLANDI: theme.palette.success.main,
    REDDEDILDI: theme.palette.error.main,
    KAPATILDI: theme.palette.text.disabled,
    TAMAMLANDI: theme.palette.success.dark,
    DANISMANLIK_SONLANDIRILDI: theme.palette.text.secondary,
    ORTAK_BULUNDU: theme.palette.primary.main,
    DEVRALINDI: theme.palette.secondary.main,
  };
  return map[status] || theme.palette.text.secondary;
};

export const getStatusColor = (name, theme) => {
  if (!name) return theme.palette.text.secondary;
  const n = name.toLowerCase();
  if (n.includes('kabul') || n.includes('onay') || n.includes('tamamlan') || n.includes('kazanıl') || n.includes('aktif'))
    return theme.palette.success.main;
  if (n.includes('red') || n.includes('iptal') || n.includes('kaybedil') || n.includes('kapat'))
    return theme.palette.error.main;
  if (n.includes('bekle') || n.includes('değerlendir') || n.includes('yazım'))
    return theme.palette.warning.main;
  if (n.includes('devam') || n.includes('süre') || n.includes('imzaland'))
    return theme.palette.primary.main;
  return theme.palette.info.main;
};
